export default "__VITE_ASSET__CZ_S3wTH__"